import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { InputEntidad, InputFile, InputFormula, ToolbarFormula, Accordion, FormLabel, Modal, FormError } from '../../common';
import {isEmptyString, validateFormula} from '../../../utils/validator';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {SECCION_TYPE} from '../../../consts/seccionType';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";


const EmisionBoletaSeccionModal = (props) => {

    const entityInit = {
        id: 0,
        idEmisionDefinicion: 0,
        idBoletaDefinicionSeccion: 0,
        descripcion: "",
        formulaCondicion: "",
        formulaSeccion: "",
        orden: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        idBoletaDefinicion: 0,
        listBoletaDefinicionSeccion: [],
        listCalculos: [],
        listVariables: [],
        listFunciones: [],
        listParametros: []
    });

    const [cabeceraOpen, setCabeceraOpen] = useState(true);

    const [formulaOpen, setFormulaOpen] = useState(true);

    const [toolbar, setToolbar] = useState({
        show: false,
        horizontal: false
    });

    const [editor, setEditor] = useState({
        fontSize: "md",
        expand: false,
        disabled: props.disabled
    });

    const [queueEvents, setQueueEvents] = useState({
        timestamps: null,
        queue: []
    });

    const [idTipoSeccion, setIdTipoSeccion] = useState(0);

    const [archivo, setArchivo] = useState({
        nombre: '',
        path: ''
    });

    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                idBoletaDefinicion: props.data.idBoletaDefinicion,
                listBoletaSecciones: props.data.listBoletaSecciones,
                listCalculos: props.data.listCalculos,
                listVariables: props.data.listVariables,
                listFunciones: props.data.listFunciones,
                listParametros: props.data.listParametros
            };
        });

        let _idTipoSeccion = 0;
        if (props.data.entity.id > 0 && props.data.entity.idBoletaDefinicionSeccion > 0) {
            const _boletaDefinicionSeccion = props.data.listBoletaDefinicionSeccion.find(f => f.id === props.data.entity.idBoletaDefinicionSeccion);
            _idTipoSeccion = _boletaDefinicionSeccion.idTipoSeccion;
            setIdTipoSeccion(_idTipoSeccion);
        }

        formSet({
            idBoletaDefinicionSeccion: props.data.entity.idBoletaDefinicionSeccion,
            descripcion: props.data.entity.descripcion,
            formulaCondicion: props.data.entity.formulaCondicion,
            formulaSeccion: (_idTipoSeccion === SECCION_TYPE.TEXTO) ? props.data.entity.formulaSeccion : '',
            orden: props.data.entity.orden
        });

        if (_idTipoSeccion === SECCION_TYPE.IMAGEN) {
            setArchivo({
                path: props.data.entity.formulaSeccion.replace(/"/g, ''),
                nombre: props.data.entity.descripcion
            });
        }

    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idBoletaDefinicionSeccion: 0,
        descripcion: "",
        formulaCondicion: "",
        formulaSeccion: "",
        orden: 0
    });

    //handles
    const handleToolbarFormulaToogleHorizontal = (horizontal) => {
        setToolbar(prevState => {
            return {...prevState, horizontal: horizontal};
        });
    }
    const handleToolbarFormulaSelect = (event) => {
        const timestamps = Date.now();
        let newQueue = queueEvents.queue.slice();
        newQueue.push({queueName: queueEvents.queueNameCurrent, timestamps: timestamps, ...event});

        setQueueEvents({
            queue: newQueue,
            timestamps: timestamps
        });
    }

    const handleUploadArchivo = (filename, data) => {

        const callbackSuccess = (response) => {
            response.text()
                .then((path) => {
                    setArchivo({
                        path: path,
                        nombre: filename
                    });
                    formSet({
                        ...formValues,
                        descripcion: filename
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                });
        };

        const paramsHeaders = {
            "Content-Type": "application/octet-stream"
        };
        ServerRequest(
            REQUEST_METHOD.POST,
            paramsHeaders,
            true,
            APIS.URLS.FILE,
            null,
            data,
            callbackSuccess,
            callbackNoSuccess,
            callbackError,
            false
        );
    }

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickConfirm = () => {
        const errors = getErrors();
        if (errors.descripcion || errors.idBoletaDefinicionSeccion || errors.orden) setCabeceraOpen(true);
        if (errors.formulaSeccion || errors.formulaCondicion || errors.archivo_nombre) setFormulaOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.idBoletaDefinicionSeccion = parseInt(formValues.idBoletaDefinicionSeccion);
            row.descripcion = formValues.descripcion;
            row.formulaCondicion = formValues.formulaCondicion;
            row.formulaSeccion = (idTipoSeccion === SECCION_TYPE.TEXTO) ? formValues.formulaSeccion :
                (idTipoSeccion === SECCION_TYPE.IMAGEN) ? `"${archivo.path}"` : '';
            row.orden = parseInt(formValues.orden);

            props.onConfirm(row);
        }
        ;
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.orden.toString().length <= 0) errors.orden = VALIDATION_MESSAGE.REQUIRED;
        else if (formValues.orden <= 0) errors.orden = 'Ingresá un número mayor a cero';
        if (formValues.idBoletaDefinicionSeccion <= 0) errors.idBoletaDefinicionSeccion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (idTipoSeccion === SECCION_TYPE.IMAGEN && archivo.path.length <= 0) errors.archivo_nombre = VALIDATION_MESSAGE.REQUIRED;

        if (idTipoSeccion === SECCION_TYPE.TEXTO) {
            const errorSeccion = getFormulaError(formValues.formulaSeccion, true);
            if (errorSeccion) errors.formulaSeccion = errorSeccion;
        }

        const errorCondicion = getFormulaError(formValues.formulaCondicion, false);
        if (errorCondicion) errors.formulaCondicion = errorCondicion;

        return errors;
    }

    function getFormulaError(formula, obligatoria) {
        if (formula.length <= 0) return obligatoria ? VALIDATION_MESSAGE.REQUIRED : null;
        const error = validateFormula(formula);
        return error ? `Fórmula incorrecta: ${error}` : null;
    }

    function ToggleEditorDisabled() {
        setEditor(prevState => {
            return {...prevState, disabled: !editor.disabled};
        });
    }

    function ToggleFormulaExpand() {
        if (!editor.expand && cabeceraOpen) {
            setCabeceraOpen(false);
        }
        setEditor(prevState => {
            return {...prevState, expand: !prevState.expand};
        });
    }

    function SetFormulaFontSizeUp() {
        let fontSize = editor.fontSize;
        if (fontSize === "xm") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "md";
        else if (fontSize === "md") fontSize = "lg";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function SetFormulaFontSizeDown() {
        let fontSize = editor.fontSize;
        if (fontSize === "lg") fontSize = "md";
        else if (fontSize === "md") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "xm";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function ToogleToolbarShow() {
        setToolbar(prevState => {
            return {
                show: !prevState.show,
                horizontal: false
            };
        });
    }


    return (
        <Modal
            size={(toolbar.show && !toolbar.horizontal) ? "xl" : "lg"}
            allowFullscreen
            title={`Sección: ${(state.entity.id > 0) ? state.entity.nombre : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.EMISION_BOLETA_SECCION_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">

                                <div id="panel-main"
                                     className={(toolbar.show && !toolbar.horizontal) ? "col-12 col-lg-8" : "col-12"}>

                                    <Accordion title="Datos" open={cabeceraOpen} onToggle={setCabeceraOpen}>
                                        <div className="row form-basic">
                                            <div className="col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                                <input
                                                    name="descripcion"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={1000}
                                                    className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                                    value={formValues.descripcion}
                                                    onChange={formHandle}
                                                    disabled={(props.disabled || idTipoSeccion === SECCION_TYPE.IMAGEN)}
                                                />
                                                <FormError message={errorOf('descripcion')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6">
                                                <FormLabel htmlFor="idBoletaDefinicionSeccion" required>Sección</FormLabel>
                                                <InputEntidad
                                                    name="idBoletaDefinicionSeccion"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.EMISION_BOLETA_DEFINICION_SECCION_MODAL}
                                                    className={`form-control ${errorOf('idBoletaDefinicionSeccion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idBoletaDefinicionSeccion}
                                                    onChange={(event) => {
                                                        if (event.target.row) {
                                                            const row = event.target.row;
                                                            formSet({
                                                                ...formValues,
                                                                idBoletaDefinicionSeccion: row.id
                                                            });
                                                            setIdTipoSeccion(row.idTipoSeccion);
                                                        } else {
                                                            formSet({
                                                                ...formValues,
                                                                idBoletaDefinicionSeccion: null
                                                            });
                                                            setIdTipoSeccion(0);
                                                        }
                                                    }}
                                                    disabled={props.disabled}
                                                    entidad="BoletaDefinicionSeccion"
                                                    filter={(row) => row.idBoletaDefinicion === state.idBoletaDefinicion}
                                                />
                                                <FormError message={errorOf('idBoletaDefinicionSeccion')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="orden" required>Orden</FormLabel>
                                                <input
                                                    name="orden"
                                                    type="number"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                                                    value={formValues.orden}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('orden')} />
                                            </div>
                                        </div>
                                    </Accordion>

                                    {[SECCION_TYPE.TEXTO, SECCION_TYPE.CODIGO_BARRAS, SECCION_TYPE.IMAGEN].includes(idTipoSeccion) &&
                                        <>
                                    <Accordion
                                        title="Fórmula"
                                        className="m-top-15"
                                        open={formulaOpen}
                                        onToggle={setFormulaOpen}
                                        actions={
                                            <div className="action m-right-20 m-top-10">
                                                {!props.disabled && !toolbar.show &&
                                                    <div onClick={(event) => ToogleToolbarShow()}
                                                         className="link float-end m-left-5">
                                                        <span className="material-symbols-outlined"
                                                              title="Mostrar asistente de fórmulas">function</span>
                                                    </div>
                                                }
                                                <div onClick={(event) => ToggleFormulaExpand()}
                                                     className="link float-end m-left-5">
                                                    {(editor.expand) ?
                                                        <span className="material-symbols-outlined"
                                                              title="Contraer editor de fórmula">zoom_in_map</span> :
                                                        <span className="material-symbols-outlined"
                                                              title="Expandir editor de fórmula">zoom_out_map</span>}
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeDown()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Disminuir tamaño de fuente">text_decrease</span>
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeUp()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Aumentar tamaño de fuente">text_increase</span>
                                                </div>
                                                {!props.disabled &&
                                                    <div onClick={(event) => ToggleEditorDisabled()}
                                                         className="link float-end m-left-5">
                                                        <span className="material-symbols-outlined"
                                                              title={(editor.disabled) ? "Cambiar a modo edición" : "Cambiar a modo lectura"}>{(editor.disabled) ? "stylus" : "search"}</span>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    >
                                        <div className="row">

                                            <div className="mb-3 col-12">
                                                <label htmlFor="formulaCondicion"
                                                       className="form-label">Condición</label>
                                                <InputFormula
                                                    name="formulaCondicion"
                                                    className={`form-control ${errorOf('formulaCondicion') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    heightNormal={50}
                                                    value={formValues.formulaCondicion}
                                                    onChange={formHandle}
                                                    onFocus={(event) => {
                                                        setQueueEvents(prevState => {
                                                            return {
                                                                ...prevState,
                                                                queueNameCurrent: "Condicion"
                                                            };
                                                        });
                                                    }}
                                                    disabled={props.disabled}
                                                    data={{
                                                        listCalculos: state.listCalculos,
                                                        listVariables: state.listVariables,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: state.listParametros,
                                                        listElementos: [],
                                                        listTiposDeclaracionJurada: []
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Condicion"
                                                />
                                                <FormError message={errorOf('formulaCondicion')} />
                                            </div>
                                            {idTipoSeccion === SECCION_TYPE.TEXTO &&
                                                <div className="col-12">
                                                    <FormLabel htmlFor="formulaSeccion" required>Contenido</FormLabel>
                                                    <InputFormula
                                                        name="formulaSeccion"
                                                        className={`form-control ${errorOf('formulaSeccion') ? 'is-invalid' : ''}`}
                                                        fontSize={editor.fontSize}
                                                        maxLength={10000}
                                                        editorExpanded={editor.expand}
                                                        value={formValues.formulaSeccion}
                                                        onChange={formHandle}
                                                        onFocus={(event) => {
                                                            setQueueEvents(prevState => {
                                                                return {
                                                                    ...prevState,
                                                                    queueNameCurrent: "BoletaSeccion"
                                                                };
                                                            });
                                                        }}
                                                        disabled={editor.disabled}
                                                        data={{
                                                            listCalculos: state.listCalculos,
                                                            listVariables: state.listVariables,
                                                            listFunciones: state.listFunciones,
                                                            listParametros: state.listParametros,
                                                            listElementos: [],
                                                            listTiposDeclaracionJurada: []
                                                        }}
                                                        queueEvents={queueEvents}
                                                        queueName="BoletaSeccion"
                                                    />
                                                    <FormError message={errorOf('formulaSeccion')} />
                                                </div>
                                            }
                                            {idTipoSeccion === SECCION_TYPE.IMAGEN &&
                                                <div className="mb-3 col-12">
                                                    <FormLabel htmlFor="archivo_nombre" required>Archivo
                                                        de imagen</FormLabel>
                                                    <InputFile
                                                        name="archivo_nombre"
                                                        placeholder="Click para adjuntar una imagen..."
                                                        className={`form-control ${errorOf('archivo_nombre') ? 'is-invalid' : ''}`}
                                                        value={archivo.nombre}
                                                        onUpload={handleUploadArchivo}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('archivo_nombre')} />
                                                </div>
                                            }
                                        </div>
                                    </Accordion>
                                        </>
                                    }

                                </div>

                                {toolbar.show &&
                                    <ToolbarFormula
                                        data={{
                                            listCalculos: state.listCalculos.filter(f => f.idTipoEmisionCalculo === 242),
                                            listVariables: state.listVariables,
                                            listFunciones: state.listFunciones,
                                            listParametros: state.listParametros,
                                            listElementos: [],
                                            listTiposDeclaracionJurada: []
                                        }}
                                        onToogleHorizontal={handleToolbarFormulaToogleHorizontal}
                                        onSelect={handleToolbarFormulaSelect}
                                        showRubros={false}
                                        showCarteles={false}
                                        showElementos={false}
                                        showEntidades={false}
                                        onClose={ToogleToolbarShow}
                                    />
                                }

                            </div>

            )}
            footerClassName="modal-footer-unset"
            footer={(<>
                            {props.onMovePrevious &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMovePrevious()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Anterior'>chevron_left</span></button>
                            }
                            {props.onMoveNext &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMoveNext()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Siguiente'>chevron_right</span></button>
                            }
                            {!props.disabled && <>
                                <button className="btn btn-primary float-end" data-dismiss="modal"
                                        onClick={(event) => handleClickConfirm()}>Aceptar
                                </button>
                                <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                            </>}
                            {props.disabled &&
                                <button className="btn back-button float-start" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver</button>
                            }
            </>)}
        />
    );
}

EmisionBoletaSeccionModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onMovePrevious: func,
    onMoveNext: func,
};

EmisionBoletaSeccionModal.defaultProps = {
    disabled: false,
    onMovePrevious: null,
    onMoveNext: null
};

export default EmisionBoletaSeccionModal;